// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__3Q-BZ","search__icon":"Search_search__icon__1rvcq","suggestions__list":"Search_suggestions__list__2C7G9"};